export default [
	{
		start: 0.05,
		end: 5,
		text: 'Mais... Je... C\'est votre photo ? Que se passe-t-il ?'
	}
]
